import { IViolation } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import {
    format,
    IValidationContext,
    LinkedService,
    StoredProcedureActivity,
    storedProcedureActivityValidators,
    validateLinkedServicePermission
} from 'shell-models-lib';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { LinkedServiceRegistryService } from 'app/registries/linked-service/linked-service-registry.service';

storedProcedureActivityValidators.validateLinkedService = async function validateLinkedService(
    activity: StoredProcedureActivity,
    value?: LinkedService,
    violation?: IViolation,
    context?: IValidationContext
): Promise<IViolation[] | undefined> {
    const result: IViolation[] = [];
    if (activity.linkedService) {
        if (__IS_FABRIC_DPE__) {
            const lsModel = Metamodel.modelOf(activity.linkedService);
            const linkedServiceRegistry = await getServiceInstance<LinkedServiceRegistryService>(
                context.contextData,
                'LinkedServiceRegistryService'
            );
            const metadata = linkedServiceRegistry.getLinkedServiceConfiguration(lsModel.name);
            if (!metadata.supportStoredProcedureActivity) {
                result.push({
                    message: () =>
                        format(
                            stringResources.ActivityNotSupportLinkedServiceError,
                            StoredProcedureActivity.MODEL.display[0],
                            metadata.displayName
                        ),
                    messageType: 'unsupported'
                });
            }
        }
        result.push(...validateLinkedServicePermission(activity.linkedService, context));
    }
    return result;
};

export { StoredProcedureActivity };
